export enum SupportedLanguages {
  PL = 'pl',
  EN = 'en',
  IT = 'it',
  ES = 'es',
  RO = 'ro',
  CS = 'cs'
}
